/**
 * Pure API-base resolvers for the web SPA.
 *
 * Default (localhost) dev and prod pass an absolute `apiDomain`/`authDomain`
 * (e.g. `http://localhost:8000`) → the client talks to that host directly, exactly
 * as before. Device mode (`make device-*`) launches Vite with an EMPTY domain, so
 * these resolve to a SAME-ORIGIN URL and the request rides the Vite `/api` (and
 * `/metadata`) proxy to the backend — no cross-origin, no CORS on the device.
 *
 * When `apiDomain` is empty and `origin` is omitted the result is a relative path
 * (`/api/v1`), which axios resolves against the current page origin — same effect.
 * These are framework-free so they unit-test under node-env vitest (no DOM).
 */

/** Versioned API base: `${domain}/api/v1`, or same-origin when `domain` is empty. */
export function resolveApiBase({ apiDomain, origin } = {}) {
  const base = apiDomain || origin || '';
  return `${base}/api/v1`;
}

/** Auth base under the versioned API: `${domain}/api/v1/auth`. */
export function resolveAuthBase({ authDomain, origin } = {}) {
  const base = authDomain || origin || '';
  return `${base}/api/v1/auth`;
}

/**
 * Site-root base (NO `/api/v1` prefix) for endpoints mounted at the Django site
 * root (e.g. `GET /metadata/options/`). Kept ABSOLUTE (`apiDomain` or `origin`) so
 * consumers that pass the full URL to axios still bypass the `/api/v1` client
 * baseURL; empty only when neither is available.
 */
export function resolveSiteBase({ apiDomain, origin } = {}) {
  return apiDomain || origin || '';
}
